const CryptoJS = require("crypto-js"); //引用AES源码js
import axios from "axios";
const key = CryptoJS.enc.Utf8.parse("9vApxLk5G3PAsJrM");
const iv = CryptoJS.enc.Utf8.parse("FnJL7EDzjqWjcaY9");

/**
 * 处理返回的加密
 * @param {*} response
 */
export const resolveGxResult = word => {
  let encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  let srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  let decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  let decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

export const cryptoHttp = axios.create();

cryptoHttp.interceptors.response.use(
  response => {
    console.info("interceptors response:", response);
    if (response.status === 200) {
      return {
        ...response,
        data: JSON.parse(resolveGxResult(response.data))
      };
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);



// WEBPACK FOOTER //
// ./src/service/servieHelpers.js